import { useEffect, useRef, useState } from "react";

/**
 * Watches a sentinel element placed right after a page's hero; once the
 * sentinel scrolls above the viewport (inside `.app-shell > .main`), flips
 * `visible` true so the caller can show a condensed sticky header in its
 * place. IntersectionObserver-driven — no scroll-event listener to throttle.
 */
export function useStickyHeaderTrigger() {
  const sentinelRef = useRef<HTMLDivElement | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = sentinelRef.current;
    const root = document.querySelector<HTMLElement>(".app-shell > .main");
    if (!el || !root) return;
    const io = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0),
      { root, threshold: 0 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return { sentinelRef, visible };
}
